import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { api, unwrap, unwrapPage } from '@/api/client';
import type { components } from '@/api/schema';

export type StaffResumen = components['schemas']['StaffUserSummary'];
export type StaffDetalle = components['schemas']['StaffUserDetail'];
export type SeccionCatalogo = components['schemas']['SectionCatalogItem'];
export type SeccionInput = NonNullable<
  components['schemas']['StaffCreateBody']['sections']
>[number];

export function useCatalogoSecciones() {
  return useQuery({
    queryKey: ['secciones'],
    queryFn: () => unwrap<SeccionCatalogo[]>(api.GET('/api/v1/admin/sections')),
    staleTime: Infinity,
  });
}

export function useStaffLista(query: { page: number; q?: string; status?: 'active' | 'disabled' }) {
  return useQuery({
    queryKey: ['staff', 'lista', query],
    queryFn: () =>
      unwrapPage<StaffResumen[]>(
        api.GET('/api/v1/admin/staff-users', { params: { query: { ...query, pageSize: 50 } } }),
      ),
    placeholderData: keepPreviousData,
  });
}

export function useStaff(id: number | null) {
  return useQuery({
    queryKey: ['staff', id],
    queryFn: () =>
      unwrap<StaffDetalle>(
        api.GET('/api/v1/admin/staff-users/{id}', { params: { path: { id: String(id) } } }),
      ),
    enabled: id !== null,
  });
}
